import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { SecurityService } from '@app/services/security.service';

import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit, OnDestroy {

  constructor(public dialog: MatDialog, private securityService: SecurityService, protected sanitizer: DomSanitizer) { }

  ngOnInit() {

  }

  ngOnDestroy(): void {
  }
}
